import StepperDataExport from '../3modules/DataExport/StepperDataExport'
import MasterDataSelectDataSetDropdown from '../2compounds/Select/MasterDataTypeDropdown'
import ConfirmationMessage from '../3modules/DataExport/ConfirmationMessage'
import FormErrorSnackbar from '../2compounds/FormErrorSnackbar'

const DataExportMasterDataTemplate = ({dataSetType, onDataSetTypeChange, handleExportButton, disabled, isErrorSnackbarOpen, setIsErrorSnackbarOpen}) => {
    const steps = ['Select Data Set', 'Export Master Data']
    const errorSnackbarMessage = 'Something went wrong. Please try it again later.'

    const selectedValuesObject = {
        'Data Set': dataSetType
    }

    const DataSetDropdown = (<MasterDataSelectDataSetDropdown value={dataSetType} onChange={onDataSetTypeChange} />)
    const Message = (<ConfirmationMessage selectedValuesObject={selectedValuesObject} />)


    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return DataSetDropdown
            case 1:
                return Message
            default:
                return 'Unknown step';
        }
    }


    return (
        <div>
            <StepperDataExport getStepContent={getStepContent} steps={steps} handleExportButton={handleExportButton} disabled={disabled}/>
            <FormErrorSnackbar isSnackbarOpen={isErrorSnackbarOpen} setIsSnackbarOpen={setIsErrorSnackbarOpen} content={errorSnackbarMessage} />
        </div>
    )
}

export default DataExportMasterDataTemplate
